import React, { useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import AuthorizationService from '../../service/AuthorizationService';
import LocalStorageService from '../../service/LocalStorageService';
import UserService from '../../service/UserService';

const checkUserType = authorities => {
  if (!authorities.includes('contract_read') && authorities.includes('video_read')) {
    return 'video_only';
  } else if (!authorities.includes('video_read') && authorities.includes('contract_read')) {
    return 'contract_only';
  } else if (authorities.includes('video_read') && authorities.includes('contract_read')) {
    return 'contract_video';
  }
  return 'locked';
};

const getProduct = userType => {
  let product = 'VIDEO';
  if (userType === 'contract_only') product = 'CONTRACT';
  return product;
};

const getUserType = () => {
  const userToken = LocalStorageService.getItem('userToken');
  const decoded = jwtDecode(userToken.token);
  const auth = decoded.authorities;
  return checkUserType(auth);
};

export default function ProductRedirect() {
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [product, setProduct] = useState('');

  useEffect(() => {
    const authorization = async () => {
      if (!AuthorizationService.loggedIn()) {
        try {
          const data = await AuthorizationService.authenticate();
          const user = await UserService.getUser();
          console.log('User after authenticate:', user);
          console.log(`data: ${data}`);
          setProduct(user.dashboardKind);
          setAuthenticated(true);
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          const user = await UserService.getUser();
          console.log('User after authenticate:', user);
          setProduct(user.dashboardKind);
        } catch (e) {
          console.log(e);
        } finally {
          console.log('user is logged in');
          setAuthenticated(true);
        }
      }
    };
    authorization();
  }, []);

  if (isAuthenticated) {
    // the whole page need to be reloaded for the sake of app to ext auto login
    if (product === 'VIDEO') window.location = '/eg/dashboard';
    else window.location = '/dashboard'; // Contract Product will have to be redirected to index.html
    return <div />;
  }
  return <div />;
}
